import { useCallback, useState } from 'react'
import { cn } from '@/common/lib/cn/cn'
import './photoPreview.css'

export type PhotoPreviewProps = {
    src?: string
    alt?: string
    width?: number
    height?: number
    className?: string
} & Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt' | 'width' | 'height'>

export const PhotoPreview = ({
    src,
    alt = '',
    width = 36,
    height = 48,
    className,
    onLoad,
    style,
    ...props
}: PhotoPreviewProps) => {
    const [fitMode, setFitMode] = useState<'wide' | 'tall' | 'unknown'>('unknown')

    const handleLoad = useCallback(
        (event: React.SyntheticEvent<HTMLImageElement>) => {
            const { naturalWidth, naturalHeight } = event.currentTarget
            const nextMode = naturalWidth >= naturalHeight ? 'wide' : 'tall'
            setFitMode(nextMode)
            onLoad?.(event)
        },
        [onLoad]
    )

    if (!src) {
        return null
    }

    return (
        <div
            className={cn('photo-preview', `photo-preview--${fitMode}`, className)}
            style={
                {
                    '--photo-preview-width': `${width}px`,
                    '--photo-preview-height': `${height}px`,
                    ...style,
                } as React.CSSProperties
            }
        >
            <img src={src} alt={alt} className='photo-preview__image' onLoad={handleLoad} {...props} />
        </div>
    )
}
